import RoutingService from 'services/routing'

const products = [{ name: 'Brisamóvel', route: RoutingService.BRISAMOVEL }]

export default products
